module.exports = __webpack_public_path__ + "img/test-tube-1.5f2f5dad.svg";